import { useEffect, useRef } from 'react';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

import { useParams } from 'next/navigation';
import Countdown from 'react-countdown';
import { TestGrid } from './styles';
import useIsMobile from 'hooks/useIsMobile';

const TestBanner = ({ name = '' }) => {
  const bannerRef = useRef(null);
  const isMobile = useIsMobile();
  const params = useParams();
  const slug = params?.slug?.[0];

  useEffect(() => {
    const banner = bannerRef.current;
    if (!banner || typeof document === 'undefined') return undefined;

    const root = document.documentElement;
    const updateOffset = () => {
      const bottom = Math.max(0, Math.round(banner.getBoundingClientRect().bottom));
      root.style.setProperty('--ttw-banner-offset', `${bottom}px`);
    };

    updateOffset();
    window.addEventListener('resize', updateOffset);
    window.addEventListener('scroll', updateOffset, { passive: true });

    const observer =
      typeof ResizeObserver === 'function' ? new ResizeObserver(updateOffset) : undefined;
    observer?.observe(banner);

    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', updateOffset);
      window.removeEventListener('scroll', updateOffset);
      root.style.removeProperty('--ttw-banner-offset');
    };
  }, []);

  // end of day of Jan 19, 2025 EST time based on user local time
  const dateFuture = new Date('2025-01-20T05:00:00Z');

  const addSToText = (number, text) => {
    return number === 1 ? `${number} ${text}` : `${number} ${text}s`;
  };

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return 0;
    }

    // Render a countdown
    return (
      <Typography variant={isMobile ? 'p2Medium' : 'h6'}>
        {addSToText(days, 'day')} {addSToText(hours, 'hour')} {addSToText(minutes, 'minute')}{' '}
        {addSToText(seconds, 'second')} to the deadline!
      </Typography>
    );
  };

  const renderText = () => {
    if (slug === 'wondertiktok') {
      return <Countdown date={dateFuture} renderer={renderer} />;
    }

    return (
      <Typography variant={isMobile ? 'p2Medium' : 'h6'}>
        {name} is taking reservations for a possible, upcoming round. Indicate interest today.
      </Typography>
    );
  };

  return (
    <TestGrid
      ref={bannerRef}
      sx={{
        zIndex: 999,
      }}
      data-cy="test-banner"
    >
      {renderText()}
    </TestGrid>
  );
};
export default TestBanner;

TestBanner.propTypes = {
  name: PropTypes.string,
  // title: PropTypes.string,
};
